export default {
  local: {
    name: 'Việt Nam',
    code: 'vi'
  },
  languages: [
    {
      name: 'Việt Nam',
      code: 'vi'
    },
    {
      name: 'English',
      code: 'en'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/module/i18n/state.js